/*The resizeType can be changed by parentSize or cropSize*/

function resizeImg (img, resizeType) {	
    var w, h, imgMarginLeft, imgMarginTop;
	var parentWidth = $(img).parent().parent().width();
	var parentHeight = $(img).parent().parent().height();
	if (parentHeight<$(img).height() || parentWidth<$(img).width()){
		var imgWidth = $(img).attr("width");
		var imgHeight = $(img).attr("height");
		var xRatio = parentWidth / imgWidth;
		var yRatio = parentHeight / imgHeight;
		
		if (resizeType !== "parentSize") {
			if ( xRatio < yRatio ) {
				w = Math.ceil(imgWidth * yRatio);
				h = parentHeight;
				imgMarginLeft = (parentWidth - w)/2;
				$(img).css("margin-left", imgMarginLeft);
			}
			else {
                w = parentWidth;
				h = Math.ceil(imgHeight * xRatio);
				imgMarginTop = (parentHeight - h)/2+"px";
				$(img).css("margin-top", imgMarginTop);
			}			
		}
		else {
			if ( xRatio > yRatio ) {
				w = Math.ceil(imgWidth * yRatio);
				h = parentHeight;
			}
			else {
                w = parentWidth;
				h = Math.ceil(imgHeight * xRatio);
			}
		}
	}
		$(img).width(w);
		$(img).height(h);
}